export function getLibraryPagePath(title) {
  return title
    .replace(/\W+/g, ' ')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/(\w)([A-Z])/g, '$1-$2'.toLowerCase())
    .toLowerCase()
}
